<template>
  <div>
    <v-dialog v-model="warningDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">
          {{ $t("globals.warning") }}
        </v-card-title>
        <v-card-text>
          {{ $t("views.claims.warning_exit_without_save_confirm") }}
        </v-card-text>
        <v-card-actions>
          <v-btn
            color
            text
            @click="
              warningDialog = false;
              warningResult = false;
            "
          >
          {{ $t("components.claim_submission.keep_editing") }}
          </v-btn>
          <v-btn
            color="primary"
            @click="
              warningDialog = false;
              warningResult = true;
            "
          >
          {{ $t("views.claims.discard_changes_and_close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <claims-history-component ref="chc"
        />
  </div>
</template>
<script>
import ClaimsHistoryComponent from "@/components/Claims/ClaimsHistoryComponent.vue";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      warningDialog: false,
      warningResult: null,
      routeData: null,
      exitWithoutWarning: false,
    };
  },
  components: {
    ClaimsHistoryComponent,
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
  },
  created() {
    console.log("claim history view created")
    window.addEventListener("beforeunload", this.unload, {capture: true});
    // window.addEventListener('unload', this.unload, {capture: true});
    // document.addEventListener("visibilitychange",this.unload);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.unload, { capture: true });
  },
  beforeRouteLeave(to, from, next) {
    console.log("claim history view: before route leave: ", this.claimSubmission, this.memberIdentity );
    // if (this.warning) {
      this.displayWarning(next);
    // } else {
    //   // window.removeEventListener("beforeunload", this.beforeUnload, {capture: true});
    //   window.removeEventListener("beforeunload", this.unload, {capture: true});
    //   next();
    // }
  },
  watch: {
    warningResult: {
      async handler(v) {
        if (v) {
          this.routeData.next();
        } else {
          if (this.routeData && this.routeData.next) {
            this.routeData.next(false);
          }
        }
      },
    },
  },
  methods: {
    unload(event) {
      if ((this.$refs.chc && !this.$refs.chc.isChanged()) || !this.$refs.chc) {
        this.exitWithoutWarning = true;
      }
      if (!this.exitWithoutWarning) {
        // console.log("unload event chv: ", event);
      event.stopPropagation();
      // event.preventDefault();
      // this.displayWarning(this.refreshAction);
      return event.returnValue = "Are you sure you want to leave the page?";
      }
    },
    refreshAction(reload) {
      if (reload) {
        location.reload();
      }
    },
    displayWarning(next) {
      if ((this.$refs.chc && !this.$refs.chc.isChanged()) || !this.$refs.chc) {
        this.exitWithoutWarning = true;
      }
      console.log(this.exitWithoutWarning);
      this.warningResult = null;
      if (this.exitWithoutWarning) {
        next();
      } else {
        this.routeData = {
          next: next,
        };
        this.warningDialog = true;
      }
    },
  },
};
</script>
